// What one plate of a bread dish is called (dish `plateUnit`). Display label only — it never
// enters a price or time calculation. COUNT is for individually-made items (omelette, dosa,
// slider) whose plateSize is 1, so the count reads as a plain quantity.
export enum BookByDishPlateUnit {
    PLATE = "PLATE",
    SERVING = "SERVING",
    COUNT = "COUNT",
}
